// src/tasks/TaskForm.jsx
import { useEffect, useState } from "react";
import api from "../../api";
import { Button, Form, Card } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";


const TaskForm = ({ onCreated }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [deadline, setDeadline] = useState(null);
  const [assignedTo, setAssignedTo] = useState("");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/users/").then(res => setUsers(res.data));
  }, []);

  const submit = () => {
    const formattedDeadline = deadline ? new DateObject(deadline).convert(gregorian).format("YYYY-MM-DD") : null;
    api.post("/tasks/", {
      title,
      description,
      deadline: formattedDeadline,
      assigned_to: assignedTo
    }).then(() => {
      setTitle("");
      setDescription("");
      setDeadline(null);
      setAssignedTo("");
      onCreated();
    });
  };

  return (
    <Card className="p-3 mb-4">
      <Form.Control
        placeholder="عنوان تسک"
        value={title}
        onChange={e => setTitle(e.target.value)}
        className="mb-2"
      />

      <Form.Control
        as="textarea"
        rows={4}
        placeholder="توضیحات تسک"
        value={description}
        onChange={e => setDescription(e.target.value)}
        className="mb-3"
      />
      <Form.Label>سررسید</Form.Label>
      <DatePicker
            value={deadline}
            onChange={setDeadline}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="bottom-right"
            inputClass="form-control"
            format="YYYY-MM-DD"
          />

      <Form.Select
        value={assignedTo}
        onChange={e => setAssignedTo(e.target.value)}
        className="mb-3"
      >
        <option value="">انتخاب کاربر</option>
        {users.map(u => (
          <option key={u.id} value={u.id}>
            {u.username}
          </option>
        ))}
      </Form.Select>

      <Button className="btn-submit" onClick={submit}>
        ایجاد تسک
      </Button>
    </Card>
  );
};

export default TaskForm;
